import ApiService from '@/services/api.service'

const QuickService = {
    getQhUserPreference( id) { 
      const requestData = {
        method: 'get',
        url: "/UserPreferences/",
        headers: {
        },
        params: { 
          UserId: id          
        }
      }     
      return ApiService.customRequest(requestData);         
    },
    
    addQhUserPreference(data){
      return ApiService.post(`/UserPreferences`,data)
    },

    updateQhUserPreference(recNo,data){
      return ApiService.put(`/UserPreferences/${recNo}`,data)
    },

    UpdateLastDailyNotes(recNo,data){
      return ApiService.put(`/UserPreferences/LastDailyNotes/${recNo}`,data)
    },

    UpdateLastLogNotes(recNo,data){
      return ApiService.put(`/UserPreferences/LastLogNotes/${recNo}`,data)
    },

    UpdateLastMarsProgram(recNo,data){
      return ApiService.put(`/UserPreferences/LastMarsProgram/${recNo}`,data)
    },
    UpdateLastMarsBuilding(recNo,data){
      return ApiService.put(`/UserPreferences/LastMarsBuilding/${recNo}`,data)
    },
    UpdateLastMarsLevel(recNo,data){
      return ApiService.put(`/UserPreferences/LastMarsLevel/${recNo}`,data)
    },
    UpdateLastSelectedType(recNo,data){
      return ApiService.put(`/UserPreferences/WorkflowID/${recNo}`,data)
    },
    UpdateLastTarsProgram(recNo,data){
      return ApiService.put(`/UserPreferences/LastTarsProgram/${recNo}`,data)
    },
    UpdateLastTarsBuilding(recNo,data){
      return ApiService.put(`/UserPreferences/LastTarsBuilding/${recNo}`,data)
    },
    UpdateLastTarsLevel(recNo,data){
      return ApiService.put(`/UserPreferences/LastTarsLevel/${recNo}`,data)
    },
    
}
  
  export default QuickService;